/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";
    declare let aptrinsic: (type: string, userInfo: Object, accountInfo?: Object) => void;

    export class LocationChooserController {
        public static $inject : string[] = [
            'CurrentUser',
            'managedCompanies',
            'LocationCollection',
            'LocationModel',
            '$dealerwareLoading',
            '$filter',
            '$state',
            '$scope',
            '$timeout',
            '$mobilityCompanyAuthentication',
            '$stateParams'];

        public filterText: string;
        public locations: any;
        public selectedLocationId: any;

        constructor(public currentUser: any,
                    public managedCompanies: any,
                    public locationCollection: any,
                    public LocationModel: any,
                    public $dealerwareLoading: any,
                    public $filter: any,
                    public $state: any,
                    public $scope: any,
                    public $timeout: any,
                    public $mobilityCompanyAuthentication: any,
                    public $stateParams: any) {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Loading...');
            this.selectedLocationId = this.$mobilityCompanyAuthentication.location ? this.$mobilityCompanyAuthentication.location.id : undefined;

            this.$scope.$on('locationAccordion:onReady', function () {
                _self.$timeout(function() {
                    $('#locationFilter').focus();
                    loader.close();
                    if (_self.managedCompanies.data.length === 1) {
                        _self.$mobilityCompanyAuthentication.setCompany(managedCompanies.data[0].data.token, managedCompanies.data[0].data.name);
                        _self.$scope.accordion.toggle(0);
                    }
                }, 1000);
            });
        }

        public get forwardState() : string {
            var _fState = 'shortcuts.dashboard';
            if (this.$stateParams && angular.isObject(this.$stateParams) && this.$stateParams.hasOwnProperty('forwardState') && this.$stateParams.forwardState) {
                _fState = this.$stateParams.forwardState;
            }
            return _fState;
        }

        public chooseCompany(index: any) : void {
            var company = this.$filter('filter')(this.managedCompanies.data, { data: { name: this.filterText }})[index].data,
                _self = this;

            this.locations = undefined;
            this.$mobilityCompanyAuthentication.setCompany(company.token, company.name);
            this.locationCollection.activeLocations({
                promise: true,
                params: { include_settings: true }
            }).then(
                function(locations: any) {
                    if (locations.data.length === 1) {
                        _self.chooseLocation(locations.data[0].data);
                    } else {
                        _self.locations = locations;
                    }
                }
            );
        }

        public chooseLocation(location: any) : void {
            this.LocationModel.show({
                promise: true,
                params: {
                    id: location.id,
                    include_address: true
                }
            }).then((loc: any) => {
                location.address = loc.data.address;
                this.$mobilityCompanyAuthentication.setLocation(location);
                this.$state.go(this.forwardState);
            });
        }
    }
    getDealerwareWebContentModule().controller('LocationChooserController', LocationChooserController);
}
